// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COLORS */
/* MEASUREMENTS */
.testModeBar[data-v-6f55b7d6] {
  margin-bottom: 0;
  text-align: center;
  font-size: 2em;
  border-radius: 0;
  height: 75px;
}
.alert-test[data-v-6f55b7d6] {
  background: #111;
  color: #fff;
  font-weight: 600;
}
.alert-in-progress[data-v-6f55b7d6],
.alert-issues[data-v-6f55b7d6] {
  background: #ffc107;
  color: #000;
  font-weight: 600;
  border-radius: 0;
}
.notificationBarTop[data-v-6f55b7d6] {
  position: fixed;
  width: 100%;
  z-index: 1029;
}
.notificationBarTop a[data-v-6f55b7d6] {
  text-decoration: underline;
}
.adminDiffControlContainer[data-v-6f55b7d6] {
  padding: 10px 15px;
}
.adminDiffControlContainer .changedKey[data-v-6f55b7d6],
.adminDiffControlContainer .deletedKey[data-v-6f55b7d6],
.adminDiffControlContainer .addedKey[data-v-6f55b7d6] {
  color: white;
}
.adminDiffControlContainer .changedKey[data-v-6f55b7d6] {
  background: #2568db;
}
.adminDiffControlContainer .deletedKey[data-v-6f55b7d6] {
  background: #d70015;
}
.adminDiffControlContainer .addedKey[data-v-6f55b7d6] {
  background: #208337;
}
.changed[data-v-6f55b7d6],
.deleted[data-v-6f55b7d6],
.new[data-v-6f55b7d6] {
  border-style: dashed;
  border-width: 2px;
}
.changed[data-v-6f55b7d6] {
  border-color: #2568db !important;
}
.deleted[data-v-6f55b7d6] {
  border-color: #d70015 !important;
}
.new[data-v-6f55b7d6] {
  border-color: #208337 !important;
}
.submissions-left-col[data-v-6f55b7d6] {
  background: #ffffff;
}
.submissions-right-col[data-v-6f55b7d6] {
  border-left: 1px solid #cccccc;
  background: whitesmoke;
}
.task-divider[data-v-6f55b7d6] {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  position: absolute;
  top: 0;
  height: 100%;
  width: 4px;
  z-index: 4;
}
.task-divider .icon[data-v-6f55b7d6] {
  display: inline-flex;
  align-items: center;
  height: 50px;
  outline: none;
  box-shadow: none;
  border-radius: 0;
  cursor: pointer;
}
.task-divider .icon[data-v-6f55b7d6]:focus {
  outline: auto;
}
.task-divider .icon[data-v-6f55b7d6]:hover,
.task-divider .icon[data-v-6f55b7d6]:focus {
  background: #e7e9ec;
}
.task-divider .task-divider-line[data-v-6f55b7d6] {
  display: inline-flex;
  height: 100%;
  background: transparent;
  padding: 1.5px;
  cursor: col-resize;
  -webkit-transition: all ease 0.15s;
  transition: all ease 0.15s;
}
.task-divider .task-divider-line[data-v-6f55b7d6]:hover {
  background: dodgerblue;
}
.issues .icon-attention-solid[data-v-6f55b7d6]:before {
  color: #ffc107;
}
.nav-item.disabled[data-v-6f55b7d6] {
  color: #999;
}
.nav-tabs[data-v-6f55b7d6] {
  flex-basis: content;
}
@media (max-width: 767px) {
.left[data-v-6f55b7d6],
  .right[data-v-6f55b7d6] {
    display: inline-block;
    width: 100%;
    padding: 5px;
}
.right[data-v-6f55b7d6] {
    text-align: right;
    border-top: 1px solid #ccc;
}
.left > .key[data-v-6f55b7d6] {
    border-bottom: 1px solid #ccc;
    width: calc(100% + 10px);
    margin: -5px -5px 5px -5px;
    padding: 5px;
}
}
@media (max-width: 767px) {
.df-public-nav.df-collapsed .list-group-item[data-v-6f55b7d6]:not(.active) {
    border-width: 0 !important;
}
}
`, "",{"version":3,"sources":["webpack://./../Page.3.vue","webpack://./public/pages/Page.3.vue"],"names":[],"mappings":"AAAA,WAAW;AACX,iBAAiB;ACEjB;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;ADAJ;ACGA;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;ADDJ;ACIA;;EAEI,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;ADFJ;ACKA;EACI,eAAA;EACA,WAAA;EACA,aAAA;ADHJ;ACAA;EAKQ,0BAAA;ADFR;ACQA;EACI,kBAAA;ADNJ;ACKA;;;EAKQ,YAAA;ADLR;ACAA;EAQQ,mBAAA;ADLR;ACHA;EAWQ,mBAAA;ADLR;ACNA;EAcQ,mBAAA;ADLR;ACSA;;;EAGI,oBAAA;EACA,iBAAA;ADPJ;ACSA;EACI,gCAAA;ADPJ;ACSA;EACI,gCAAA;ADPJ;ACSA;EACI,gCAAA;ADPJ;ACSA;EAEI,mBAAA;ADRJ;ACUA;EACI,8BAAA;EACA,sBAAA;ADRJ;ACUA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;ADRJ;ACAA;EAWQ,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ADRR;ACSQ;EACI,aAAA;ADPZ;ACSQ;;EAEI,mBAAA;ADPZ;AChBA;EA4BQ,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;EACA,0BAAA;ADTR;ACUQ;EACI,sBAAA;ADRZ;ACaA;EACI,cAAA;ADXJ;ACcA;EACI,WAAA;ADZJ;ACeA;EACI,mBAAA;ADbJ;ACqBA;AACI;;IAEI,qBAAA;IACA,WAAA;IACA,YAAA;ADnBN;ACqBE;IACI,iBAAA;IACA,0BAAA;ADnBN;ACqBE;IACI,6BAAA;IACA,wBAAA;IACA,0BAAA;IACA,YAAA;ADnBN;AACF;ACsBA;AACI;IACI,0BAAA;ADpBN;AACF","sourcesContent":["/* COLORS */\n/* MEASUREMENTS */\n.testModeBar {\n  margin-bottom: 0;\n  text-align: center;\n  font-size: 2em;\n  border-radius: 0;\n  height: 75px;\n}\n.alert-test {\n  background: #111;\n  color: #fff;\n  font-weight: 600;\n}\n.alert-in-progress,\n.alert-issues {\n  background: #ffc107;\n  color: #000;\n  font-weight: 600;\n  border-radius: 0;\n}\n.notificationBarTop {\n  position: fixed;\n  width: 100%;\n  z-index: 1029;\n}\n.notificationBarTop a {\n  text-decoration: underline;\n}\n.adminDiffControlContainer {\n  padding: 10px 15px;\n}\n.adminDiffControlContainer .changedKey,\n.adminDiffControlContainer .deletedKey,\n.adminDiffControlContainer .addedKey {\n  color: white;\n}\n.adminDiffControlContainer .changedKey {\n  background: #2568db;\n}\n.adminDiffControlContainer .deletedKey {\n  background: #d70015;\n}\n.adminDiffControlContainer .addedKey {\n  background: #208337;\n}\n.changed,\n.deleted,\n.new {\n  border-style: dashed;\n  border-width: 2px;\n}\n.changed {\n  border-color: #2568db !important;\n}\n.deleted {\n  border-color: #d70015 !important;\n}\n.new {\n  border-color: #208337 !important;\n}\n.submissions-left-col {\n  background: #ffffff;\n}\n.submissions-right-col {\n  border-left: 1px solid #cccccc;\n  background: whitesmoke;\n}\n.task-divider {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 4px;\n  z-index: 4;\n}\n.task-divider .icon {\n  display: inline-flex;\n  align-items: center;\n  height: 50px;\n  outline: none;\n  box-shadow: none;\n  border-radius: 0;\n  cursor: pointer;\n}\n.task-divider .icon:focus {\n  outline: auto;\n}\n.task-divider .icon:hover,\n.task-divider .icon:focus {\n  background: #e7e9ec;\n}\n.task-divider .task-divider-line {\n  display: inline-flex;\n  height: 100%;\n  background: transparent;\n  padding: 1.5px;\n  cursor: col-resize;\n  -webkit-transition: all ease 0.15s;\n  transition: all ease 0.15s;\n}\n.task-divider .task-divider-line:hover {\n  background: dodgerblue;\n}\n.issues .icon-attention-solid:before {\n  color: #ffc107;\n}\n.nav-item.disabled {\n  color: #999;\n}\n.nav-tabs {\n  flex-basis: content;\n}\n@media (max-width: 767px) {\n  .left,\n  .right {\n    display: inline-block;\n    width: 100%;\n    padding: 5px;\n  }\n  .right {\n    text-align: right;\n    border-top: 1px solid #ccc;\n  }\n  .left > .key {\n    border-bottom: 1px solid #ccc;\n    width: calc(100% + 10px);\n    margin: -5px -5px 5px -5px;\n    padding: 5px;\n  }\n}\n@media (max-width: 767px) {\n  .df-public-nav.df-collapsed .list-group-item:not(.active) {\n    border-width: 0 !important;\n  }\n}\n","\n@import \"/lib/Colors.less\";\n\n.testModeBar {\n    margin-bottom: 0;\n    text-align: center;\n    font-size: 2em;\n    border-radius: 0;\n    height: 75px;\n}\n\n.alert-test {\n    background: #111;\n    color: #fff;\n    font-weight: 600;\n}\n\n.alert-in-progress,\n.alert-issues {\n    background: @warning;\n    color: #000;\n    font-weight: 600;\n    border-radius: 0;\n}\n\n.notificationBarTop {\n    position: fixed;\n    width: 100%;\n    z-index: 1029;\n    a {\n        text-decoration: underline;\n    }\n}\n@added: #208337;\n@changed: #2568db;\n@deleted: #d70015;\n.adminDiffControlContainer {\n    padding: 10px 15px;\n    .changedKey,\n    .deletedKey,\n    .addedKey {\n        color: white;\n    }\n    .changedKey {\n        background: @changed;\n    }\n    .deletedKey {\n        background: @deleted;\n    }\n    .addedKey {\n        background: @added;\n    }\n}\n\n.changed,\n.deleted,\n.new {\n    border-style: dashed;\n    border-width: 2px;\n}\n.changed {\n    border-color: @changed !important;\n}\n.deleted {\n    border-color: @deleted !important;\n}\n.new {\n    border-color: @added !important;\n}\n.submissions-left-col {\n    // container: leftSubmissions / inline-size;\n    background: #ffffff;\n}\n.submissions-right-col {\n    border-left: 1px solid #cccccc;\n    background: whitesmoke;\n}\n.task-divider {\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    position: absolute;\n    top: 0;\n    height: 100%;\n    width: 4px;\n    z-index: 4;\n\n    .icon {\n        display: inline-flex;\n        align-items: center;\n        height: 50px;\n        outline: none;\n        box-shadow: none;\n        border-radius: 0;\n        cursor: pointer;\n        &:focus {\n            outline: auto;\n        }\n        &:hover,\n        &:focus {\n            background: @light-gray-dark;\n        }\n    }\n\n    .task-divider-line {\n        display: inline-flex;\n        height: 100%;\n        background: transparent;\n        padding: 1.5px;\n        cursor: col-resize;\n        -webkit-transition: all ease 0.15s;\n        transition: all ease 0.15s;\n        &:hover {\n            background: dodgerblue;\n        }\n    }\n}\n\n.issues .icon-attention-solid:before {\n    color: @warning;\n}\n\n.nav-item.disabled {\n    color: #999;\n}\n\n.nav-tabs {\n    flex-basis: content;\n}\n// @container leftSubmissions (max-width: 576px) {\n//     .button-controls {\n//         width: 100%;\n//     }\n// }\n\n@media (max-width: 767px) {\n    .left,\n    .right {\n        display: inline-block;\n        width: 100%;\n        padding: 5px;\n    }\n    .right {\n        text-align: right;\n        border-top: 1px solid #ccc;\n    }\n    .left > .key {\n        border-bottom: 1px solid #ccc;\n        width: calc(100% + 10px);\n        margin: -5px -5px 5px -5px;\n        padding: 5px;\n    }\n}\n\n@media (max-width: 767px) {\n    .df-public-nav.df-collapsed .list-group-item:not(.active) {\n        border-width: 0 !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
